// extracted by mini-css-extract-plugin
export default {"container":"j1Xxrfzus0duxOteQj2e","box":"nJqsjrKROvPTbrcH5ayn"};